import { Card } from '../../../Common/Charts/Card';
import { currency } from '../../../Common/Util/currency';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Indicators = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div className="d-flex flex-column flex-grow-1" style={{ gap: '10px' }}>
            <Card
                title="Valor Incremento"
                value={
                    currency.formatToBrCurrency(
                        chartData?.indexes[0]?.valor_incremento
                    ) || 0
                }
            />
            <Card
                title="Valor Complemento Federal"
                value={
                    currency.formatToBrCurrency(
                        chartData?.indexes[0]?.valor_complemento_federal
                    ) || 0
                }
            />
            <Card
                title="Valor Complemento Local"
                value={
                    currency.formatToBrCurrency(
                        chartData?.indexes[0]?.valor_complemento_local
                    ) || 0
                }
            />
        </div>
    );
};
